import React from 'react'

import { NO } from '../../utils/constants/constant'

const Badge = ({ status, label }) => {
  const statusClassMap = {
    Pending: 'pending-status',
    Closed: 'close-status',
    Voided: 'close-status',
    'Deposit Settlement': 'deposit-status',
    Overdue: 'overdue-status',
    'Partial Received': 'partial-status',
    Received: 'received-status',
    'N/A': 'na-status',
    [NO]: 'na-status',
    Flagged: 'overdue-status',
    'Pre-sales': 'presales-status',
    CR: 'overdue-status',
    'Gap Detected': 'deposit-status',
    'Progress Regression': 'pending-status',
    'Estimation CR': 'partial-status',
    Open: 'pending-status',
    'Gap Alert': 'overdue-status',
    default: 'success-bg',
  }

  const className = `badge ${statusClassMap[status] || statusClassMap.default}`
  return (
    <div className="badge-wrap">
      <span className={className}>{label || status}</span>
    </div>
  )
}

export default Badge
